<template>

<center>
    <div class="card card-body agatrs-card-style">
         <Header pageTitle="Edit Organization" class="card-container"></Header>
            <div class="col-md-8 center">
            
                <form @submit.prevent="updateOrganizations">
                    <div class="row ">
                        <div class="col-md-3 col-md-6">
                            <base-input type="text" label="Organization " placeholder="Organization Name" v-model="organization.name">
                            </base-input>
                        </div>
                        <div class="col-md-3 col-md-6">
                            <base-input label="Organization Abbreviation" v-model="organization.abbreviation" placeholder="Organization Abbreviation" addon-left-icon="tim-icons icon-single-02"></base-input>
                        </div>
                    </div>
                    <br>       
                    <router-link :to="'/admin/organizations'" class="btn btn-secondary"><span> Back </span></router-link>
                     <base-button native-type="submit" type="primary" class="btn-fill">
                        Update Information
                    </base-button>
                    
                </form>
            </div>
    </div>
</center>

            
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import Treeselect from "@riophae/vue-treeselect";
import {
    Select,
    Option
} from 'element-ui'
import Header from "@/components/App/Header.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
    name:'AdminEditOrganization',
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        Treeselect,
        Header

    },
    data() {
        return {
            id : this.$route.params.id
        };
    },
    computed: {
        ...mapGetters({
            organization: 'organization/organization',
        }),
    },
    mounted() {
        this.getOrganization(this.id)
        // this.getOrderMetadata()
    },
    methods: {
        ...mapActions({
            updateOrganization: 'organization/updateOrganization',
            getOrganization: 'organization/getOrganization', 
        }),
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        
       updateOrganizations(id) {
            let ctx = this;
            ctx.updateOrganization().then(()=>{
                ctx.getOrganization(this.id);
            });
        }
    }
};
</script>

<style>

.more-width{

    width: 50%;
}
</style>
